import { useTranslations } from '~/src/hooks/useTranslations'
import AuthenticationDialogTitle from '~/src/components/auth/dialogs/AuthenticationDialogTitle'

const ForgotPasswordTitle = () => {
  const { t } = useTranslations()

  return (<AuthenticationDialogTitle>{ t('auth.forgotPassword') }</AuthenticationDialogTitle>)
}

export default ForgotPasswordTitle
